import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../Firebase';
import './ChallengePage.css';
import Modal from "react-responsive-modal";
import 'react-tagsinput/react-tagsinput.css';
import backgroundBase from "../assets/background_login.png"
import iconUp from "../../assets/cards/icon_up.svg";
import iconDown from "../../assets/cards/icon_down.svg";
import icon_share from "../../assets/cards/icon_share.svg";
import CreatePollModalContent from '../Home/CreatePollModalContent';
import PollsSection from './PollsSection/PollsSection';
import IdeaModal from "./IdeaModal";
import HistoricModal from "./HistoricModal";
import TrelloCreateBoard from "../Account/CreateTrelloBoard";
import Fade from '@material-ui/core/Fade';
import SnackBar from '../SnackBar/SnackBar';
import * as firebase from 'firebase';
import AssignCapsuleModalContent from '../Home/AssignCapsuleModalContent';
import clip from "../assets/clip.svg";
import uuid from 'uuid/v1';
import DeleteModalContent from './DeleteModalContent';
import IdeaSection from './IdeaSection/IdeaSection';
import InfoSection from './InfoSection/InfoSection';
import LikeComponent from '../Card/LikeComponent'
import close_icon from "../assets/left-arrow.svg";
import confirmationDesktop from '../../assets/confirmation_v2.svg';
import { withStyles } from '@material-ui/core/styles';
import { CircularProgress, CardHeader } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import editImage from '../../assets/pencil.svg';
import EditionPage from './EditionPage';
import { ReviewCard } from './ReviewCard';
import Rater from 'react-rater';
import RatingCapsuleModal from "../Account/ProgressCapsules/RatingCapsuleModal";

class ChallengePage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      current_user: {},
      capsule_id: '',
      title: '',
      current_uid: '',
      capsule: [],
      createPollOpen: false,
      polls: [],
      ideaOpen: false,
      ideas: [],
      historicOpen: false,
      confirmationOpen: false,
      assignCapsuleOpen: false,
      deleteOpen: false,
      deleteConfirmed: false,
      direction: 'up',
      snackbarUpDownOpen: false,
      snackReopen: false,
      needToRemoveIfUndo: false,
      loading: true,
      editable: true,
      filterByRelevance: false,
      imageLoading: false,
      creationIdeaLoading: false,
      openEdit: false,
      ratingCapsule: 0,
      firstRate: 0,
      ratingModalOpen: false,
    };
    this.updateAfterRate = this.updateAfterRate.bind(this)
  }

  componentDidMount() {
    document.body.style.background = "#F8F9FB";
    var caps_id = this.props.match.params.id
    this.setState({ capsule_id: caps_id })
    let uid;
    if (this.props.firebase.auth.currentUser) {
      uid = this.props.firebase.auth.currentUser.uid
      this.setState({ current_uid: uid })
      this.loadData(uid, caps_id);
    }
  }

  loadData(uid, caps_id) {
    this.props.firebase.db
      .collection("users")
      .doc(uid)
      .get()
      .then(doc => {
        this.setState({
          current_user: doc.data()
        });
      });

    this.props.firebase.db
      .collection("capsules")
      .doc(caps_id)
      .get()
      .then(doc => {
        this.setState({
          capsule: doc.data(),
          direction: doc.data().managers.includes(this.props.firebase.auth.currentUser.uid) ? 'up' : 'down',
          editable: doc.data().status || doc.data().assigneeId ? false : true,
        })
        // let ratingList = this.state.capsule.ratingList || [];
        // this.setState({ ratingList: ratingList })
        // this.ratingFunction(ratingList);
        // let isRate = ratingList.find(rating => this.state.current_uid === rating.user)
        // if (isRate) {
        //   this.setState({ ratingOpen: false });
        // }
      })

      .then(() => {
        this.props.firebase.db
          .collection("capsules")
          .doc(caps_id)
          .collection("ideas")
          .get()
          .then(querysnapshot => {
            let ideas = querysnapshot.docs.map(doc => {
              let data = doc.data()
              return {
                id: doc.id,
                ...data
              }
            });
            this.setState({ ideas: ideas })
          })

        this.props.firebase.db
          .collection("capsules")
          .doc(caps_id)
          .collection("polls")
          .get()
          .then(querysnapshot => {
            let polls = querysnapshot.docs.map(doc => {
              let data = doc.data()
              return {
                id: doc.id,
                ...data
              }
            });

            let answeredPolls = {};
            querysnapshot.docs.forEach(doc => {
              let data = doc.data()
              answeredPolls[doc.id] = data.collectedUsers ? data.collectedUsers.includes(this.props.firebase.auth.currentUser.uid) : false
            });

            this.setState({ polls: polls, answeredPolls, loading: false })
          })
      }).catch(errors => {
        console.error(errors);
      })
  }

  onClose = () => {
    return this.props.history.goBack()
  }

  topCapsule = () => {
    const { capsule } = this.state

    return (
      <div className="cointainer">
        <div className="img-filter-cps no-margin">
          <img className="close_icon_pos" onClick={this.onClose} src={close_icon} alt="close" />
          <div className="d-flex justify-content-center align-items-center title-container">
            <div className="title-challenge p-3">{capsule.title}</div>
          </div>
          <div onClick={this.openHistoric} className="cursor-pointer text-right historic-btn">
            <span className="historic-btn-text">Historique</span>
          </div>
        </div>
      </div>
    )
  }

  btnCapsule = () => {
    const { capsule, capsule_id, direction, editable, loading } = this.state
    return (
      <div className="cointainer" hidden={!editable}>
        <div className="row text-center no-margin">
          <div className="col"></div>
          <div className="col">
            <Fade in={!loading}>
              <div className="d-flex justify-content-center">
                <TrelloCreateBoard
                  capsuleName={capsule.title}
                  assigneeName={capsule.assigneeId}
                  capsule={capsule}
                  capsuleId={capsule_id}
                  currentUserId={this.props.firebase.auth.currentUser.uid}
                />
                <Tooltip title={direction === 'up' ? 'Up capsule' : 'Down capsule'} aria-label="up/down">
                  <img className="position-icon-cps centerbtn-cps"
                    alt="upDown"
                    src={direction === 'up' ? iconUp : iconDown}
                    onClick={direction === 'up' ? () => this.upCapsule(capsule_id) : () => this.downCapsule(capsule_id)}
                  />
                </Tooltip>
                <Tooltip title="Propulser" aria-label="propulser">
                  <img className="position-icon-cps" alt="propell" src={icon_share} onClick={() => this.openAssignCapsule()} />
                </Tooltip>
              </div>
            </Fade>
          </div>
          <div className="col"></div>
        </div>
      </div>
    )
  }

  openSnackbar = () => {
    this.setState({ snackbarUpDownOpen: true });
  };

  closeSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ snackbarUpDownOpen: false, needToRemoveIfUndo: false });
  };

  closeReopenSnack = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ snackReopen: false });
  }

  upCapsule = async (capsuleID) => {
    let managers = this.state.capsule.managers
    this.setState({
      needToRemoveIfUndo: !managers.includes(this.state.current_user.manager)
    })
    await this.props.firebase.db.collection('capsules').doc(capsuleID).update({
      managers: firebase.firestore.FieldValue.arrayUnion(this.state.current_user.manager)
    })
    this.openSnackbar();
  }

  downCapsule = async (capsuleID) => {
    let managers = this.state.capsule.managers
    this.setState({
      needToRemoveIfUndo: !managers.includes(this.props.firebase.auth.currentUser.uid)
    })
    await this.props.firebase.db.collection('capsules').doc(capsuleID).update({
      managers: firebase.firestore.FieldValue.arrayUnion(this.props.firebase.auth.currentUser.uid)
    })
    this.openSnackbar();
  }

  undoUpDown = async () => {
    const { direction, capsule_id, needToRemoveIfUndo } = this.state
    if (needToRemoveIfUndo) {
      if (direction === 'up') {
        await this.props.firebase.db.collection('capsules').doc(capsule_id).update({
          managers: firebase.firestore.FieldValue.arrayRemove(this.state.managerID)
        })
        this.closeSnackbar();
      }
      else {
        await this.props.firebase.db.collection('capsules').doc(capsule_id).update({
          managers: firebase.firestore.FieldValue.arrayRemove(this.props.firebase.auth.currentUser.uid)
        })
        this.closeSnackbar();
      }
    }
    this.closeSnackbar();
  }

  assignCapsule = () => {
    this.openAssignCapsule();
  };

  openAssignCapsule = () => {
    this.setState({
      assignCapsuleOpen: true
    })
  }

  closeAssignCapsule = () => {
    this.setState({
      assignCapsuleOpen: false
    })
  }

  openEdit = () => {
    this.setState({
      openEdit: true
    })
  }

  closeEdit = () => {
    this.setState({
      openEdit: false
    })
  }

  // infoCapsule = () => {
  //   const { capsule, polls, ideas, editable, current_uid, ratingCapsule, ratingOpen } = this.state;
  //   let polls_length = polls.length;
  //   let ideas_length = ideas.length;
  //   let tags = capsule.tags ? capsule.tags : [];
  //   let status = capsule.status ? capsule.status : '';
  //   let nbVotes = capsule.ratingList ? capsule.ratingList.length : ''
  //   let attachments = capsule.attachments ? capsule.attachments : [];
  //   return (
  //     <div className="cointainer d-flex flex-colum justify-content-center">
  //       <div className="w-75 position-relative d-flex flex-column align-items-center">
  //         <div className="chal-info-container d-flex flex-column align-items-center w-100">
  //           <div className="mt-4" hidden={editable}></div>
  //           <div className="chal-numbers-container p-2">
  //             <h1 className="stats-cps text-left">{polls_length} Sondages</h1>
  //             <h1 className="stats-cps text-left">{ideas_length} Idées</h1>
  //             <div className="chal-actions">
  //               <LikeComponent
  //                 idcapsule={this.state.capsule_id}
  //                 card={"challenge"}
  //               />
  //               <Tooltip title="Editer" aria-label="editer" hidden={capsule.creator !== current_uid}>
  //                 <img src={editImage} alt="edit" className="edit-image pt-2 cursor-pointer" onClick={this.openEdit}></img>
  //               </Tooltip>
  //             </div>
  //           </div>
  //           <div className="sizing-tags d-flex overflow-auto justify-content-center">
  //             {tags.map((tag, index) => <div className="idea-tag" key={index}>
  //               <span className="idea-tag-text">#{tag}</span>
  //             </div>)}
  //           </div>
  //           <div hidden={status !== 'finish'}>
  //             <Rater onRate={({ rating }) => { this.onRatingCaps(rating) }} rating={ratingCapsule} total={5} interactive={ratingOpen} />
  //             <h1 className="rate-text-card">{ratingCapsule}/5 ({nbVotes} votes)</h1>
  //           </div>
  //         </div>
  //         <div className="pb-2 pt-2">
  //           {attachments.map((attachment, index) =>
  //             <a href={attachment.url} key={attachment.url}>
  //               <div className="d-flex">
  //                 <img src={clip} className="mr-3 pb-1" alt="attach" />
  //                 <h1 className="attachment-link cursor-pointer">
  //                   {attachment.fileName}
  //                 </h1>
  //               </div>
  //             </a>
  //           )}
  //         </div>
  //         <p className="cps-description d-flex justify-content-center">{capsule.description}</p>
  //       </div>
  //     </div>
  //   )
  // }

  // ratingFunction = (ratingList) => {
  //   let nbrRate = ratingList ? ratingList.length : 0;
  //   let total = 0;
  //   let finalRate = 0;
  //   ratingList.forEach((rating) => {
  //     total += rating.rate;
  //   })
  //   finalRate = nbrRate === 0 ? 0 : total / nbrRate;
  //   this.setState({ ratingCapsule: Math.round(finalRate) })
  // }

  // onRatingCaps = (rating) => {
  //   const { current_uid, ratingList } = this.state
  //   this.setState({ firstRate: rating });
  //   let isRate = ratingList.find(rating => current_uid === rating.user)
  //   if (isRate === undefined) {
  //     this.openRating()
  //   }
  // }

  // openRating = () => {
  //   this.setState({
  //     ratingModalOpen: true
  //   })
  // }

  // addRating = (rating, commentaire) => {
  //   const { current_uid, ratingList, capsule_id, current_user } = this.state
  //   let list = ratingList;
  //   const name = current_user.firstname + ' ' + current_user.lastname;
  //   const image = current_user.image_url_profile ? current_user.image_url_profile : '';
  //   const position = current_user.position ? current_user.position : '';
  //   list.push({ rate: rating, user: current_uid, commentaire: commentaire, username: name, position: position, image: image })
  //   this.ratingFunction(list)
  //   this.setState({ ratingOpen: false });
  //   this.props.firebase.db
  //     .collection("capsules")
  //     .doc(capsule_id)
  //     .set({ ratingList: list }, { merge: true })
  //     .catch((error) => console.error(error))
  // }

  // closeRating = () => {
  //   this.setState({
  //     ratingModalOpen: false,
  //   })
  // }

  updateAfterRate(ratingList) {
    console.log(this.state)
    let { capsule } = this.state;
    capsule.ratingList = ratingList;
    this.setState({ capsule })
  }

  openCreatePoll = () => {
    this.setState({
      createPollOpen: true
    })
  }

  closeCreatePoll = () => {
    this.setState({
      createPollOpen: false
    })
  }


  addToPolls = (poll) => {
    const timestamp = Date.now();
    const { capsule_id, current_user } = this.state
    const newHistoric = { date: timestamp, firstname: current_user.firstname, lastname: current_user.lastname, picture: current_user.image_url_profile, status: "poll" }
    this.props.firebase.db.collection('capsules').doc(capsule_id).collection('polls').add(poll)
      .catch(errors => {
        console.error(errors);
      }).then(() => {
        this.props.firebase.db.collection('capsules').doc(capsule_id).collection('historic').add(newHistoric)
          .catch(errors => {
            console.error(errors);
          });
      })
      .then(() => {
        window.location.reload()
      })
    let { polls } = this.state;
    polls.push(poll)
    this.setState({
      polls
    })
  }

  markPollAsAnswered = (pollID) => {
    let answeredPolls = this.state.answeredPolls;
    answeredPolls[pollID] = true;
  }

  addToIdeas = async (idea) => {
    this.setState({ creationIdeaLoading: true });
    const { capsule_id, current_user } = this.state
    const timestamp = Date.now();
    let current_idea = idea;
    let attachmentListUrl;
    const newHistoric = { date: timestamp, firstname: current_user.firstname, lastname: current_user.lastname, picture: current_user.image_url_profile, status: "idea" }
    if (idea.attachments) {
      attachmentListUrl = [];
      for (const attachment of idea.attachments) {
        let attachmentUuid = uuid();
        await this.props.firebase.storage.ref(`PJ/${attachmentUuid}`).put(attachment)
        let url = await this.props.firebase.storage.ref('PJ').child(attachmentUuid).getDownloadURL()
        attachmentListUrl.push({ fileName: attachment.name, url });
      }
      current_idea.attachments = attachmentListUrl;
      current_idea.urlList = null;
    }
    this.props.firebase.db.collection('capsules').doc(capsule_id).collection('ideas').add(current_idea)
      .then(doc => {
        let { ideas } = this.state;

        ideas.push({
          id: doc.id,
          ...idea
        })
        this.setState({
          ideas,
        })
      })
      .catch(errors => {
        console.error(errors);
      }).then(() => {
        this.props.firebase.db.collection('capsules').doc(capsule_id).collection('historic').add(newHistoric)
          .catch(errors => {
            console.error(errors);
          });
      })
    this.props.firebase.db.collection('capsules').doc(capsule_id).update({ nbIdeas: firebase.firestore.FieldValue.increment(1) })
      .then(
        this.setState({ creationLoading: false }),
        this.closeIdea());
    this.openConfirmation();
  }

  onDelete = () => {
    const { capsule_id } = this.state
    this.props.firebase.db.collection('capsules').doc(capsule_id).delete();
  }

  onReopen = () => {
    const { capsule_id } = this.state
    const timestamp = Date.now();
    this.props.firebase.db.collection('capsules').doc(capsule_id).update({ status: "pending" })
    this.setState({ snackReopen: true })
    let newHistoric = { date: timestamp, firstname: this.state.current_user.firstname, lastname: this.state.current_user.lastname, picture: this.state.current_user.image_url_profile, status: "reopen" }
    this.props.firebase.db.collection('capsules').doc(capsule_id).collection('historic').add(newHistoric)
  }

  openIdea = () => {
    this.setState({
      ideaOpen: true
    })
  }

  closeIdea = () => {
    this.setState({
      ideaOpen: false,
      creationIdeaLoading: false
    })
  }

  openHistoric = () => {
    this.setState({
      historicOpen: true
    })
  }

  closeHistoric = () => {
    this.setState({
      historicOpen: false,
    })
  }

  test = () => {
    this.setState({ idea: true });
    this.setState({
      ideaOpen: false,
    })
  }

  openConfirmation = () => {
    this.setState({
      confirmationOpen: true,
      imageLoading: true,
    })
  }

  closeConfirmation = () => {
    this.setState({
      confirmationOpen: false
    })
  }

  openDelete = () => {
    this.setState({
      deleteOpen: true
    })
  }

  closeDelete = (status) => {
    this.setState({
      deleteOpen: false
    })
    if (status === 'accept') {
      this.setState({ deleteConfirmed: true })
    }
  }

  onDeleteExited = () => {
    const { deleteConfirmed } = this.state
    if (deleteConfirmed) {
      this.props.history.goBack();
    }
  }

  onLoadImage = () => {
    this.setState({ imageLoading: false })
  }

  render() {
    const { capsule_id, capsule, direction, current_uid, ideas, imageLoading, creationIdeaLoading, polls, editable, current_user } = this.state
    const { classes } = this.props
    var divStyle = {
      backgroundImage: 'url(' + capsule.image_url_capsule + ')',
    };

    var divStyleGrey = {
      backgroundImage: 'url(' + backgroundBase + ')'
    };

    let imgCapsule

    if (capsule.image_url_capsule) {
      imgCapsule = divStyle;
    } else {
      imgCapsule = divStyleGrey;
    }

    return (
      <div>
        <div>
          <div style={imgCapsule} className="img-background-cps">
            {this.topCapsule()}
          </div>
          <div className="cps-white-background_top">
            {this.btnCapsule()}
            {/* {this.infoCapsule()} */}
            <InfoSection
              updateAfterRate={this.updateAfterRate}
              openEdit={this.openEdit}
              polls={polls}
              ideas={ideas}
              capsule={capsule}
              capsule_id={capsule_id}
              editable={editable}
              current_user={current_user} />
          </div>
          <div className="cps-white-background_middle mt-3 pt-1">
            <PollsSection
              polls={this.state.polls}
              answeredPolls={this.state.answeredPolls}
              capsuleID={this.state.capsule_id}
              capsule={this.state.capsule}
              markPollAsAnswered={this.markPollAsAnswered}
              openCreatePoll={this.openCreatePoll}
              closeCreatePoll={this.closeCreatePoll} />
          </div>
          <Modal
            open={this.state.createPollOpen}
            onClose={this.closeCreatePoll}
            center
            showCloseIcon={true}
            styles={(window.innerWidth > 768) ? styles_desktop : styles_mobile}
          >
            <CreatePollModalContent onClose={this.closeCreatePoll}
              onAddPolls={this.addToPolls}
            />
          </Modal>
          <div className="cps-white-background_bottom mt-3 mb-3">
            {/* {this.ideaCapsule()} */}
            <IdeaSection
              ideas={ideas}
              openIdea={this.openIdea}
              capsule={capsule}
              capsuleId={capsule_id}
              changeIdeaFilter={this.changeIdeaFilter}
              openDelete={this.openDelete}
              onReopen={this.onReopen}
            >
            </IdeaSection>
          </div>
          <div hidden={!capsule.ratingList} className="cps-white-background_bottom mt-3 mb-3">
            <ReviewCard
              capsule={capsule}
            />
          </div>
          <Modal
            open={this.state.ideaOpen}
            onClose={this.closeIdea}
            center
            showCloseIcon={true}
            styles={(window.innerWidth > 768) ? styles_desktop : styles_mobile}
          >
            <IdeaModal onClose={this.closeIdea}
              onAddIdea={this.addToIdeas}
              onTest={this.test}
              creator={current_uid}
              loading={creationIdeaLoading} />
          </Modal>
        </div>
        <Modal
          open={this.state.historicOpen}
          onClose={this.closeHistoric}
          center
          showCloseIcon={true}
          styles={(window.innerWidth > 768) ? styles_desktop : styles_mobile}
        >
          <HistoricModal
            onClose={this.closeHistoric}
            capsuleId={capsule_id}
          />
        </Modal>
        <Modal
          open={this.state.confirmationOpen}
          onClose={this.closeConfirmation}
          center
          showCloseIcon={true}
          classNames={{ 'closeButton': 'closeIconModal' }}
          styles={styles_confirmation}
          closeIconSvgPath={<path d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z" fill="#FFFFFF"></path>}
        >
          {imageLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
          <img src={confirmationDesktop} className="h-100 w-100 p-0 object-fit-cover" onLoad={this.onLoadImage} alt="confirmation" />
        </Modal>
        <Modal
          open={this.state.assignCapsuleOpen}
          onClose={this.closeAssignCapsule}
          center
          showCloseIcon={true}
          styles={(window.innerWidth > 768) ? styles_desktop : styles_mobile}
        >
          <AssignCapsuleModalContent
            onClose={this.closeAssignCapsule}
            openConfirmation={this.openConfirmation}
            capsuleID={capsule_id} />

        </Modal>
        <Modal
          open={this.state.deleteOpen}
          onClose={this.closeDelete}
          center
          showCloseIcon={true}
          styles={styles_delete}
          onExited={this.onDeleteExited}
        >
          <DeleteModalContent
            onClose={this.closeDelete}
            openDelete={this.openDelete}
            capsuleID={capsule_id} />

        </Modal>
        <Modal
          open={this.state.openEdit}
          onClose={this.closeEdit}
          center
          showCloseIcon={true}
          styles={(window.innerWidth > 768) ? styles_desktop : styles_mobile}
        >
          <EditionPage
            openConfirmation={this.openConfirmation}
            onClose={this.closeEdit}
            capsuleId={capsule_id}
            capsule={capsule} />

        </Modal>
        {/* <Modal
          open={this.state.ratingModalOpen}
          onClose={this.closeRating}
          center
          showCloseIcon={true}
          styles={(window.innerWidth > 768) ? styles_desktop : styles_mobile}
        >
          <RatingCapsuleModal
            onClose={this.closeRating}
            addRating={this.addRating}
            firstRate={this.state.firstRate}
          />
        </Modal> */}
        <SnackBar
          open={this.state.snackbarUpDownOpen}
          handleClose={this.closeSnackbar}
          messageSnackBar={direction === 'up' ? "Capsule remontée" : "Capsule descendue"}
          undo={this.undoUpDown} />

        <SnackBar
          open={this.state.snackReopen}
          handleClose={this.closeReopenSnack}
          messageSnackBar={'Votre capsule a été réactivé'}
          remove={true}
        />
      </div>
    )
  }
}

const styles_desktop = {
  overlay: {
    display: "block",
    position: "fixed",
    left: 0,
    top: 0,
    zIndex: 9999,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.79)",
    overflow: "auto",
  },
  modal: {
    boxShadow: 'none',
    borderRadius: '4px',
    minHeight: "601px",
    maxWidth: "395px",
    top: "10%",
    padding: "0px",
  }
};

const styles_mobile = {
  overlay: {
    display: "block",
    position: "fixed",
    left: 0,
    top: 0,
    zIndex: 9999,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.79)",
    overflow: "auto",
    padding: "0px",
  },
  modal: {
    boxShadow: 'none',
    minHeight: "100%",
    width: "100%",
    padding: "0px",
  }
};

const styles_confirmation = {
  overlay: {
    display: "block",
    position: "fixed",
    left: 0,
    top: 0,
    zIndex: 9999,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.79)",
    overflow: "auto",
    padding: "0px",
  },
  modal: {
    width: (window.innerWidth > 768) ? '20vw' : '80vw',
    top: '20vh',
    padding: "0px",
    background: "rgba(0,0,0,0)",
  }

};

const styles_delete = {
  overlay: {
    display: "block",
    position: "fixed",
    left: 0,
    top: 0,
    zIndex: 9999,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.79)",
    overflow: "auto",
  },
  modal: {
    boxShadow: 'none',
    borderRadius: '4px',
    minHeight: "355px",
    maxWidth: "321px",
    top: "10%",
    padding: "0px",
  }
};

const styles_loader = theme => ({
  root: {
  },
  buttonProgress: {
    color: '#0070A2',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -20,
    marginLeft: -12,
  },
});


const ChallengePageB = withRouter(withFirebase(withStyles(styles_loader)(ChallengePage)));

export default ChallengePageB;